const actions = {
  SET_STATE: "history/SET_STATE",
  LIST: "history/LIST",
};

export default actions;
